
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const handleWhatsApp = () => {
    window.open('https://wa.me/5544999921632?text=Olá! Gostaria de solicitar uma proposta para serviços de engenharia.', '_blank');
  };

  const scrollToContact = () => {
    document.getElementById('contato')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.4)), url('https://readdy.ai/api/search-image?query=Professional%20civil%20engineering%20construction%20site%20with%20modern%20buildings%20under%20construction%2C%20safety%20equipment%20visible%2C%20clean%20geometric%20lines%2C%20professional%20atmosphere%2C%20golden%20hour%20lighting%20with%20warm%20tones%2C%20minimalist%20composition%20with%20copy%20space%20on%20left%20side%20for%20text%20overlay%2C%20high%20contrast%20architectural%20elements%2C%20construction%20cranes%20and%20scaffolding%20in%20background%2C%20professional%20engineering%20workspace%20ambiance&width=1920&height=1080&seq=hero-bg&orientation=landscape')`
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center min-h-screen py-20">
          <div className="text-white">
            <div className="mb-6">
              <span className="inline-flex items-center px-4 py-2 bg-yellow-500/20 text-yellow-400 rounded-full text-sm font-medium backdrop-blur-sm">
                <i className="ri-map-pin-line mr-2"></i>
                Maringá — PR • Presencial e Remoto
              </span>
            </div>
            
            <h1 className="text-5xl lg:text-7xl font-bold mb-6 leading-tight">
              Regiane <span className="text-yellow-400">Fialho</span>
            </h1>
            
            <h2 className="text-2xl lg:text-3xl font-semibold mb-8 text-gray-200">
              Engenheira Civil
            </h2>
            
            <p className="text-xl lg:text-2xl mb-12 text-gray-300 font-light">
              PPCP | Projetos & Obras | Segurança do Trabalho
            </p>
            
            <p className="text-lg mb-12 text-gray-400 max-w-2xl leading-relaxed">
              Engenharia orientada a resultados para empresas e construtoras. 
              Especialista em otimização de processos, controle de qualidade e segurança.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button size="lg" onClick={scrollToContact}>
                <i className="ri-mail-line"></i>
                Solicitar Proposta
              </Button>
              <Button variant="outline" size="lg" onClick={handleWhatsApp}>
                <i className="ri-whatsapp-line"></i>
                Falar no WhatsApp
              </Button>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button 
          onClick={() => document.getElementById('sobre')?.scrollIntoView({ behavior: 'smooth' })}
          className="text-white/70 hover:text-white transition-colors cursor-pointer"
        >
          <i className="ri-arrow-down-line text-2xl"></i>
        </button>
      </div>
    </section>
  );
}
